import CustomerRegisterStockist from './components/customer-register-stockist';
import ProductBookViewingButton from './components/product-book-viewing-button.vue';
import BookViewingModal from './components/book-viewing-modal';
import LoadMore from './components/load-more';
import LoginForm from './components/login-form';
import ModalEmailProject from './components/modal-email-project.vue';
import ModalLogin from './components/modal-login.vue';
import ModalProjectBook from './components/modal-project-book.vue';
import ModalBase from './components/modal-base';
import ProjectBookItem from './components/project-book-item.vue';
import ProjectBookList from './components/project-book-list.vue';
import ProjectBookProject from './components/project-book-project';
import ProjectItemAddButton from './components/project-item-add-button';
import ProjectItemAddMultipleButton from './components/project-item-add-multiple-button';
import ProjectItemBuilder from './components/project-item-builder';
import RetailersUpdateDetailsButton from './components/retailers-update-details-button';
import RetailersUploadImagesButton from './components/retailers-upload-images-button';
import UpdateDetailsModal from './components/update-details-modal';
import UploadImagesModal from './components/upload-images-modal';
import Alpine from 'alpinejs';
import focus from '@alpinejs/focus';
import collapse from '@alpinejs/collapse';
import intersect from '@alpinejs/intersect';
import persist from '@alpinejs/persist';
import Headroom from 'headroom.js';
import axios from './config/axios';
import alpineSlider from './components/alpine-slider.js'
import search from './typesense/search.js';

function hotspotTabs() {
	if ($(".js-explore-tabs")[0]) {
		$(".js-explore-tabs").each(function (i) {
			var tabsContainer = $(this).closest('.explore-wrapper').find('.slick-dots');
			var tabID = '#slick-slide-control0' + i
			var tabIcon = $(this).attr('data-tab-icon');
			var tabName = $(this).attr('data-tab-name');

			if (tabIcon.length != 0) {
				if ($(window).width() > 900) {
					tabsContainer.find(tabID).css({
						"background-image": "url('" + tabIcon + "')",
						"padding": "0.4rem 1rem 0.37rem 2.3rem"
					});
				}
			}

			tabsContainer.find(tabID).text(tabName)
		});
	}
}



function brochureFormSelection() {
	if ($(".js-brochure-form")[0]) {
		var brochureSelection = $(".js-brochure-form").find(".js-selection");
		var $selectedVersionsInput = $(".js-brochure-form").find('[name="selectedVersions"]');

		$(".js-brochure-checkbox").change(function () {
			brochureSelection.empty();
			var selectedVersions = [];

			$(".js-brochure-checkbox:checked").each(function () {
				var brochureName = $(this).attr("data-title");
				var brochureVersion = $(this).attr("data-version");
				var brochureID = $(this).attr("id");
				brochureSelection.append("<label class='js-selection-item' for='" + brochureID + "'><p>" + brochureName + "</p></label>");

				if (selectedVersions.indexOf(brochureVersion) == -1) {
					selectedVersions.push(brochureVersion);
				}
			});

			$selectedVersionsInput.val(selectedVersions.join(' | '));
		});
	}
}

window.addEventListener('servd.csrfloaded', function () {
	axios.defaults.headers['X-CSRF-Token'] = window.csrfTokenValue;
});

$(document).ready(function () {
	$(".explore__icon").click(function () {
		$(this).closest(".explore__marker").toggleClass("explore__marker--active");
	});
});


// ******************************
// national-developers hidden 'other' field
// ******************************
$(document).ready(function () {
	if ($("#form-input-servicesInterestedIn")[0]) {
		$('#form-input-servicesInterestedIn').on('change', function () {
			// console.log("change")
			if ($(this).val() == 'Other') {
				$('#form-input-other').removeClass("form__input-hidden");
			} else {
				$('#form-input-other').addClass("form__input-hidden");
			}
		});
	}
});



// ******************************
// Video hero
// ******************************
if ($(".js-video-hero")[0]) {
	if ($(window).width() > 740) {
		var headerHeight = $(".header").outerHeight() + 5
		$(".js-video-hero").css('margin-top', - headerHeight)
		$(".js-video-hero .video-hero__content").css('margin-top', headerHeight)

		if ($(".video-hero--dark")[0]) {
			$(".header").addClass("header--transparent-dark header--dark")
		} else {
			$(".header").addClass("header--transparent-light")
		}
	} else {
		if ($(".video-hero--dark")[0]) {
			$(".header").addClass("header--dark")
		}
	}
}


// SWATCH SELECTION FORM
// On form select change this clones a specified hidden element & inserts it in to the form, along with various attributes needed to submit the swatch request
$(document).on('change', '.js-range-select', function () {
	var rangeValue = $(this).val();
	var finishID = '#' + rangeValue + '-finishes';
	var finishOptions = $(finishID).clone();
	var finishContainer = $(this).closest(".form__row").next('.js-finish-container');

	var finishFieldID = finishContainer.attr('data-id');
	var finishLabelText = finishContainer.attr('data-label-text');
	var finishName = finishContainer.attr('data-select-name');

	finishContainer.html(finishOptions);

	finishContainer.find("label").text(finishLabelText).attr('for', finishFieldID);
	finishContainer.find("select").attr('id', finishFieldID).attr('name', finishName);

	// console.log(rangeValue)
	// console.log(finishID)

	// console.log(finishFieldID)
	// console.log(finishLabelText)
	// console.log(finishName)
});

function showExtraStockistFields($checkBoxField) {
	if ($checkBoxField.is(':checked')) {
		$('[data-stockist-extra]').find('input, textarea').prop('required', true);
		$('[data-stockist-extra]').show();
	} else {
		$('[data-stockist-extra]').find('input, textarea').prop('required', false);
		$('[data-stockist-extra]').hide();
	}
}

$(document).ready(function () {
	var $checkBoxField = $('[data-stockist-checkbox]');

	if ($checkBoxField.length) {
		$checkBoxField.on('change', function () {
			showExtraStockistFields($(this));
		});

		showExtraStockistFields($checkBoxField);
	}
});


// ADDS A CLASS TO HEADER ON SCROLL
function scrollClass() {
	$(".js-scroll").each(function () {
		var topOfWindow = $(window).scrollTop();
		if (topOfWindow >= 200) {
			$(this).addClass('header--small');
		} else if (topOfWindow < 90) {
			$(this).removeClass('header--small');
		}
	});
}

function zoomImageContainer() {
	[...document.getElementsByClassName('zoom')].forEach(imgEl => {
		const src = imgEl.currentSrc;
		const bgPos = imgEl.style.objectPosition ?? '50% 50%';
		// const originalDimensions = imgEl.height;
		const container = document.createElement("div");
		const child = document.createElement("div");

		container.classList.add('product-images__zoom-container');
		container.style.height = '100%';
		container.style.position = 'relative';

		child.classList.add('product-images__zoom-image');
		child.style.backgroundImage = 'url(' + src + ')';
		child.style.backgroundPosition = bgPos;
		child.style.backgroundRepeat = 'no-repeat';

		container.appendChild(child);

		if (imgEl.parentElement.tagName.toLowerCase() === 'picture') {
			imgEl.parentElement.replaceWith(container);
		} else {
			imgEl.replaceWith(container);
		}
	});
}

function zoomImage() {
	[...document.querySelectorAll('.productDetailPage .product-images__zoom-container')].forEach(containerEl => {
		const parentEl = containerEl.closest('li');
		const button = parentEl.querySelector('.productSlider__zoom');
		const zoomIn = button.querySelector('.zoom-in');
		const zoomOut = button.querySelector('.zoom-out');
		const image = containerEl.querySelector('.product-images__zoom-image');
		let zoomed = false;

		button.addEventListener('click', (evt) => {
			evt.preventDefault();

			if (zoomed) {
				containerEl.classList.remove('product-images__zoom-container--zoomed');
				zoomIn.style.display = 'block';
				zoomOut.style.display = 'none';
				zoomed = false;
			} else {
				containerEl.classList.add('product-images__zoom-container--zoomed');
				zoomIn.style.display = 'none';
				zoomOut.style.display = 'block';
				// Default to centre origin on first zoom
				image.style.transformOrigin = '50% 50%';
				zoomed = true;
			}
		});

		containerEl.addEventListener('mousemove', (evt) => {
			const rect = containerEl.getBoundingClientRect();
			const x = ((evt.clientX - rect.left) / rect.width) * 100;
			const y = ((evt.clientY - rect.top) / rect.height) * 100;
			image.style.transformOrigin = `${x}% ${y}%`;
		});

		containerEl.addEventListener('mouseleave', () => {
			containerEl.classList.remove('product-images__zoom-container--zoomed');
			zoomIn.style.display = 'block';
			zoomOut.style.display = 'none';
			zoomed = false;
		});
	});
}

$(window).on("load", function () {
	zoomImageContainer();
	zoomImage();
});

$(document).ready(function () {
	brochureFormSelection();

	$('.animate-reveal')
		.waypoint(function (direction) {
			if (direction === 'down') {
				$(this.element).addClass('animate-reveal--show')
			}
		}, {
			offset: '85%'
		});

	$(".js-tracking-brochure-download").on("click", function () {
		pintrk("track", "lead", { lead_type: "Download" });
	});


	$(".js-inspirationCards-slider").slick({
		slidesToShow: 3,
		slidesToScroll: 1,
		dots: true,
		arrows: true,
		infinite: true,
		adaptiveHeight: true,
		lazyLoad: 'ondemand',
		responsive: [
			{
				breakpoint: 800,
				settings: {
					slidesToShow: 2,
				},
			},
			{
				breakpoint: 570,
				settings: {
					slidesToShow: 1,
				},
			},
		],
	});

	$(".productCards-slider").slick({
		slidesToShow: 4,
		slidesToScroll: 1,
		dots: false,
		arrows: true,
		infinite: true,
		adaptiveHeight: true,
		lazyLoad: 'ondemand',
		responsive: [
			{
				breakpoint: 800,
				settings: {
					slidesToShow: 2,
				},
			},
			{
				breakpoint: 570,
				settings: {
					slidesToShow: 1,
				},
			},
		],
	});

	$(".js-linked-products-slider").slick({
		slidesToShow: 3,
		slidesToScroll: 1,
		dots: false,
		arrows: true,
		infinite: true,
		adaptiveHeight: true,
		lazyLoad: 'ondemand',
		responsive: [
			{
				breakpoint: 800,
				settings: {
					slidesToShow: 2,
				},
			},
			{
				breakpoint: 570,
				settings: {
					slidesToShow: 1,
				},
			},
		],
	});

	$(".js-feature-slider").slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		dots: true,
		arrows: false,
		speed: 600,
		autoplaySpeed: 6000,
		autoplay: true,
	});

	$(".js-slider").slick({
		arrows: true,
		dots: false,
		infinite: true,
		speed: 300,
		slidesToShow: 3,
		slidesToScroll: 1,
		autoplay: false,
		responsive: [
			{
				breakpoint: 769,
				settings: {
					slidesToShow: 1,
				},
			},
		],
	});

	$(".js-gallery-slider").slick({
		arrows: true,
		dots: false,
		infinite: true,
		speed: 300,
		slidesToShow: 4,
		slidesToScroll: 1,
		autoplay: false,
		responsive: [
			{
				breakpoint: 960,
				settings: {
					slidesToShow: 3
				},
			},
			{
				breakpoint: 600,
				settings: {
					slidesToShow: 2
				},
			},
			{
				breakpoint: 420,
				settings: {
					slidesToShow: 1
				},
			},
		],
	});

	$(".js-full-bleed-slider").slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		dots: true,
		lazyLoad: 'ondemand',
		infinite: true,
		adaptiveHeight: false
	});

	$(".js-explore-slider").slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		dots: false,
		infinite: true,
		adaptiveHeight: true
	});

	$(".js-explore-slider-fade").slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		dots: true,
		arrows: false,
		infinite: true,
		adaptiveHeight: true,
		fade: true,
	});

	hotspotTabs();

	$(".js-productSlider").slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		asNavFor: ".js-productSliderNav",
		dots: false,
	});

	$(".js-productSliderNav").slick({
		slidesToShow: 3,
		slidesToScroll: 1,
		asNavFor: ".js-productSlider",
		dots: true,
		centerMode: true,
		focusOnSelect: true,
	});

	$(".js-fittedRangeSlider").slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		asNavFor: ".js-fittedRangeSliderNav",
		dots: false,
		lazyLoad: 'ondemand',
		nextArrow: '[data-ranges-gallery-next]',
		prevArrow: '[data-ranges-gallery-prev]',
		// The main gallery should always render as one full-width slide per page.
		// Variable-width allows portrait assets to shrink the slide width to the
		// image content, which breaks the fixed 16:9 frame.
		variableWidth: false,
		responsive: [
			{
				breakpoint: 600,
				settings: {
					dots: true,
					dotsClass: 'slick-dots range-slick-dots'
				}
			}
			// You can unslick at a given breakpoint now by adding:
			// settings: "unslick"
			// instead of a settings object
		]
	});

	$(".js-configurationsSlider").slick();



	$(window).on('rangezoommodalopen', function () {
		$(".js-fittedRangeSliderZoom").slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			asNavFor: ".js-fittedRangeSlider",
			dots: true,
			adaptiveHeight: true,
			lazyLoad: 'ondemand',
			nextArrow: '[data-ranges-zoom-next]',
			prevArrow: '[data-ranges-zoom-prev]',
			dotsClass: 'slick-dots range-slick-dots'
		});
	});
	$(window).on('rangezoommodalclose', function () {
		$(".js-fittedRangeSliderZoom").slick('unslick');
	});

	$(".js-fittedRangeSliderNav").slick({
		slidesToShow: 5,
		slidesToScroll: 1,
		asNavFor: ".js-fittedRangeSlider",
		dots: false,
		centerMode: false,
		focusOnSelect: true,
		lazyLoad: 'ondemand',
		variableWidth: true,
		nextArrow: '[data-preview-next]',
		prevArrow: '[data-preview-prev]',
		responsive: [
			{
				breakpoint: 600,
				settings: "unslick"
			}
			// You can unslick at a given breakpoint now by adding:
			// settings: "unslick"
			// instead of a settings object
		]

	});

	$(window).on('finishChanged', function(e) {
		let finishId = e.target.dataset.finishId;
		if (finishId !== 'null') {
			let slide = $('.js-fittedRangeSlider').find(`.slick-slide:not(.slick-cloned) [data-finish-id="${ finishId }"]`).not('.slick-cloned').parent().parent();
			let bigSlider = $('.js-fittedRangeSlider');
			let navSlider = $('.js-fittedRangeSliderNav');
			if (slide !== undefined && slide.attr('data-slick-index') !== undefined) {
				console.log(slide.attr('data-slick-index'));
				console.log(bigSlider.slick('slickCurrentSlide'));
				if (slide.attr('data-slick-index') != bigSlider.slick('slickCurrentSlide')) {
					$('.js-fittedRangeSlider').slick('slickGoTo', slide.attr('data-slick-index'));
				}
				if (slide.attr('data-slick-index') != navSlider.slick('slickCurrentSlide')) {
					$('.js-fittedRangeSliderNav').slick('slickGoTo', slide.attr('data-slick-index'));
				}
			}
		}
	});


	$(".js-smallSlider").slick({
		dots: true,
		infinite: true,
		speed: 300,
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: false,
	});

	$(".js-heroSlider").slick({
		dots: true,
		infinite: true,
		speed: 300,
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: false,
		arrows: false,
	});

	$('[data-grid-card]').each(function(){
		var $this = $(this);
		var id = $this.attr('data-id');
		var slides = 6;

		if ($this.find(".js-swatchSlider-"+id+" [data-id='swatch']").length > 6) {
			$this.find(".js-swatchSlider-"+id).addClass('px-9')
			slides = 5;
		}

		var images = $this.find(".js-cardSwatchSlider-"+id).slick({
			dots: true,
			infinite: false,
			speed: 300,
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: false,
			autoplay: false,
			//asNavFor: ".js-swatchSlider-"+id,
			focusOnSelect: true,
		}).on('beforeChange', function(e, slick, current, next){
			var input = swatches.find("[data-id='swatch']").eq(next);

			input.trigger('click');
			//$this.find('[x-text="selectedFinish"]').text(input.find('input').val())

			//swatches.slick('slickGoTo', next)
		});

		var swatches = $this.find(".js-swatchSlider-"+id).slick({
			dots: false,
			infinite: false,
			speed: 300,
			slidesToShow: slides,
			slidesToScroll: slides,
			arrows: true,
			autoplay: false,
			//asNavFor: ".js-cardSwatchSlider-"+id,
			//focusOnSelect: true,
			variableWidth: true,
		})

		$this.find(".js-swatchSlider-"+id+" [data-id='swatch']").each(function(i){
			$(this).on('click', function(){
				$this.find(".js-swatchSlider-"+id+" [data-id='swatch']").each(function(){
					$(this).removeAttr('data-checked')
				})
				$(this).attr('data-checked', true)
				$this.find('[data-x-text="selectedFinish"]').text($(this).attr('data-colour'))
				images.slick('slickGoTo', i)
			})
		})

	});




	$(".js-brochure-slider").slick({
		dots: true,
		infinite: false,
		slidesToShow: 3,
		slidesToScroll: 1,
		arrows: true,
		responsive: [
			{
				breakpoint: 1000,
				settings: {
					slidesToShow: 2
				},
			},
			{
				breakpoint: 600,
				settings: {
					slidesToShow: 1
				},
			},
		],
	});

	$(".js-brochureSlider").slick({
		initialSlide: $('.js-brochureSlider').data('initial-slide'),
		slidesToShow: 1,
		slidesToScroll: 1,
		asNavFor: ".js-brochureSliderNav",
		dots: false
	});

	$(".js-brochureSliderNav").slick({
		slidesToShow: 5,
		asNavFor: ".js-brochureSlider",
		dots: false,
		focusOnSelect: true,
		responsive: [
			{
				breakpoint: 1200,
				settings: {
					slidesToShow: 4,
				},
			},
		]
	});

	var setInitialSlideOnBrochureNav = function () {
		var brochureNav = document.querySelector('.js-brochureSlider')

		if (brochureNav) {
			brochureNav.slick.slickGoTo($('.js-brochureSlider').data('initial-slide'));
		}
	};

	setInitialSlideOnBrochureNav();

	$(window).on('resize orientationchange', setInitialSlideOnBrochureNav);

	$(".js-iconNavigationSlider").slick({
		infinite: false,
		slidesToShow: 6,
		slidesToScroll: 1,
		dots: false,
		arrows: true,
		speed: 600,
		responsive: [
			{
				breakpoint: 900,
				settings: {
					slidesToShow: 5.5,
				},
			},
			{
				breakpoint: 750,
				settings: {
					slidesToShow: 4.5,
				},
			},
			{
				breakpoint: 600,
				settings: {
					slidesToShow: 3.5,
				},
			},
			{
				breakpoint: 450,
				settings: {
					slidesToShow: 2.5,
				},
			},
		],
	});

	$(".js-smoothscroll").on("click", function (event) {
		const target = $(this).attr("href");

		if (!target.startsWith("#")) {
			return true;
		}

		event.preventDefault();

		$("html, body").animate(
			{
				scrollTop: $(target).offset().top - $(".header").height(),
			},
			500
		);

		return false;
	});

	// ACCORDION
	$(".js-accordion__toggle").click(function () {
		$(this).siblings(".js-accordion__toggle").removeClass("open");
		$(this).toggleClass("open");
	});

	$(".js-filter-toggle").click(function (e) {
		e.preventDefault();
		$(this).parent(".filter__container").toggleClass("active");
	});

	// NAVIGATION
	// if ($(window).width() < 1200) {
		$(".navigation__trigger").on("click", function () {
			$(this).toggleClass("navigation__trigger--active");
			$(".navigation").toggleClass("navigation--active");
			$(".navigation__dropdown").removeClass("navigation__dropdown--active");
		});

		$(".navigation__item").click(function (e) {
			if (e.target == this) {
				$(this)
					.find(".navigation__dropdown")
					.addClass("navigation__dropdown--active");
			}
		});

		$(".navigation__back").click(function (event) {
			event.preventDefault();
			$(this)
				.parent(".navigation__dropdown")
				.removeClass("navigation__dropdown--active");
		});
	// }

	if ($(window).width() < 700) {
		// Adds second click for mobile devices so the overlay can display
		$(".editorial__overlay").each(function () {
			$(this)
				.parent(".editorial__link")
				.on("click", function (event) {
					event.preventDefault();
					var editorialLink = $(this).attr("href");
					$(this).on("click", function () {
						window.location = editorialLink;
					});
				});
		});
	}

	// VIDEO MODAL
	$(".js-video-modal-toggle").on("click", function () {
		var videoSrc = $(this).attr("data-video-src");
		if ($(".video-modal").hasClass("video-modal--active")) {
			$(".video-modal").removeClass("video-modal--active");
			$(".video-modal .video-modal__video").attr("src", "");
		} else {
			$(".video-modal").addClass("video-modal--active");
			$(".video-modal .video-modal__video").attr("src", videoSrc);
		}
	});

	// VIDEO MODAL
	$(".js-embed-modal-toggle").on("click", function () {
		var videoSrc = $(this).attr("data-embed-src");
		if ($(".embed-modal").hasClass("embed-modal--active")) {
			$(".embed-modal").removeClass("embed-modal--active");
			$(".embed-modal .embed-modal__embed").attr("src", "");
		} else {
			$(".embed-modal").addClass("embed-modal--active");
			$(".embed-modal .embed-modal__embed").attr("src", videoSrc);
		}
	});

	// Adding header height to sticky column
	if ($(".productDetails--sticky")[0]) {
		var headerHeight = $(".header").outerHeight();
		$(".productDetails__column.text--right").css({
			top: headerHeight,
		});
	}

	scrollClass();

	// Temporarily removing instagram feed as not working
	// Instafeed
	//if (InstagramToken != undefined) {
	//	var feed = new Instafeed({
	//		accessToken: InstagramToken,
	//		limit: 5
	//	});
	//	feed.run();
	//}
});

$(window).on('scroll', function () {
	scrollClass();
});

export const eventBus = new Vue();

Vue.component('BookViewingModal', BookViewingModal);
Vue.component('ProductBookViewingButton', ProductBookViewingButton);
Vue.component('LoadMore', LoadMore);
Vue.component('LoginForm', LoginForm);
Vue.component('EmailProjectModal', ModalEmailProject);
Vue.component('LoginModal', ModalLogin);
Vue.component('ProjectBookModal', ModalProjectBook);
Vue.component('BaseModal', ModalBase);
Vue.component('ProjectBookItem', ProjectBookItem);
Vue.component('ProjectBookList', ProjectBookList);
Vue.component('ProjectBookProject', ProjectBookProject);
Vue.component('ProjectItemAddButton', ProjectItemAddButton);
Vue.component('ProjectItemAddMultipleButton', ProjectItemAddMultipleButton);
Vue.component('ProjectItemBuilder', ProjectItemBuilder);
Vue.component('RetailersUpdateDetailsButton', RetailersUpdateDetailsButton);
Vue.component('RetailersUploadImagesButton', RetailersUploadImagesButton);
Vue.component('UpdateDetailsModal', UpdateDetailsModal);
Vue.component('UploadImagesModal', UploadImagesModal);
Vue.component('CustomerRegisterStockist', CustomerRegisterStockist);

new Vue({
	el: '#app',
	delimiters: ['${', '}'],
	data() {
		return {
			isLoggedIn: false
		}
	},
	beforeMount() {
		console.log(this.isLoggedIn);
		this.isLoggedIn = (this.$el.attributes['data-authorised'].value === 'true');
	},
	created() {
		eventBus.$on('login-success', this.authorised);
	},
	beforeDestroy() {
		eventBus.$off('login-success', this.authorised);
	},
	methods: {
		requiresLogin(url) {
			eventBus.$emit('login-required', { redirectUrl: url });
		},
		openEmailProjectModal() {
			eventBus.$emit('email-project', null);
		},
		authorised() {
			this.isLoggedIn = true;
		}
	}
});

const header = document.querySelector('header.scrollhide');
if (header) {
	const headroom = new Headroom(header, {
		offset : 100,
		tolerance : 20,
	});
	headroom.init();
}

window.Alpine = Alpine;
Alpine.plugin(focus);
Alpine.plugin(collapse);
Alpine.plugin(intersect);
Alpine.plugin(persist);
Alpine.plugin(alpineSlider);
Alpine.plugin(search);
Alpine.start()
